var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"520px","id":_vm.$cookies.get('USERID'),"src":"https://lesenaoappdev.innohub13.de"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }